/* eslint-disable prettier/prettier */
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaApi from "@/kuaa/kuaa-api";
import moment from "moment";
import Swal from "sweetalert2";
import session from "@/kuaa/kuaa-sessions";
import $ from 'jquery';

const kuaaFnc = {
    

    /**
     * 금액을 구좌 단위로 변환 (정수면 소수점 없이, 아니면 소수점 둘째자리까지)
     * @param {number} amount
     * @returns {string}
     */
    formatGuja(amount) {
        const guja = amount / 4000000;
        if (Number.isInteger(guja)) {
            return guja + '구좌';
        } else {
            return guja.toFixed(2) + '구좌';
        }
    },


    comm_code_url: URL_CONST.GET_COMBO_BOX_CODE_LIST,

    /**
     * Selectbox 공통코드 대분류 조회
     * @param codeGrpId
     * @param searchText
     * @param callback
     */
    fncListCmmCodeL(codeGrpId, searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: codeGrpId,
                perPage: 100,
                codeNm: searchText
            },
            'post',
            callback,
            true
        );
    },

    /**
     * Selectbox 공통코드 중분류 조회
     * @param codeGrpId
     * @param lCodeCd
     * @param searchText
     * @param callback
     */
    fncListCmmCodeM(codeGrpId, lCodeCd, searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: codeGrpId,
                lCodeCd: lCodeCd,
                perPage: 100,
                codeNm: searchText
            },
            'post',
            callback,
            true
        );
    },

    /**
     * Selectbox 공통코드 소분류 조회
     * @param codeGrpId
     * @param lCodeCd
     * @param mCodeCd
     * @param searchText
     * @param callback
     */
    fncListCmmCodeS(codeGrpId, lCodeCd, mCodeCd, searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: codeGrpId,
                lCodeCd: lCodeCd,
                mCodeCd: mCodeCd,
                perPage: 100,
                codeNm: searchText
            },
            'post',
            callback,
            true
        );
    },
    
    /**
     * Branch List
     * searchText : 검색 단어
     */
    fncBranchList(searchText, callback) {
        kuaaApi.sendServer(
            URL_CONST.GET_BRANCH_LIST,
            {
                perPage: 1000,
                codeNm: searchText
            },
            'post',
            callback,
            true
        );
    },

    /**
     * 임원 직위 공통코드 List
     * searchText : 검색 단어
     */
    fncOrgLevelList(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'LEVEL_CD',
                perPage: 1000,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 학위 공통코드 List
     * searchText : 검색 단어
     */
    fncDegreeCdList(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'DEGREE_CD',
                perPage: 1000,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },    
    
    /**
     * 직종 공통코드 List
     * searchText : 검색 단어
     */
    fncWorkList(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'WORK_CD',
                perPage: 1000,
                codeNm: searchText
            },
            'post',
            callback,
            true
        );
    },
    
    /**
     * 직종 공통코드 List
     * searchText : 검색 단어
     */
    fncWorkHisGbList(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'WORKHIS_GB',
                perPage: 1000,
                codeNm: searchText
            },
            'post',
            callback,
            true
        );
    },

    /**
     * Staff Type 조회
     * searchText : 검색 단어
     */
    fncStaffTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'STAFF_CD',
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 회원등급 조회
     * searchText : 검색 단어
     */
    fncMemberLevelTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'MLEVEL_CD',
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 회비구분
     * searchText : 검색 단어
     */
    fncFeeCdTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'FEE_CD',
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },
    
    /**
     * 회비등급구분
     * searchText : 검색 단어
     */
    fncFeeLevelCdTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'FEE_LEVEL_CD',
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

  /**
   * 납부방법
   * searchText : 검색 단어
   */
  fncFeeWayTypes(searchText, callback) {
    kuaaApi.sendServer(
      this.comm_code_url,
      {
          codeGrpId: "FEE_WAY_CD",
        perPage: 100,
        codeNm: searchText
      },
      "post",
      callback,
        true
    );
  },

    /**
     * 은행코드
     * searchText : 검색 단어
     */
    fncBankCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "BANK_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 본적코드
     * searchText : 검색 단어
     */
    fncBornCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "BORN_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 카드코드
     * searchText : 검색 단어
     */
    fncCardCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "CARD_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 포상코드
     * searchText : 검색 단어
     */
    fncPrizeCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "PRIZE_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

        /**
     * 경조코드
     * searchText : 검색 단어
     */
    fnckyjoCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "KYJO_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

        /**
     * 경조 업체 코드
     * searchText : 검색 단어
     */
    fncStoreCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "STORE_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

            /**
     * 경조 조치 코드
     * searchText : 검색 단어
     */
    fncActCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "ACT_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

     /**
     * 학위 구분 코드
     * searchText : 검색 단어
     */
    fncDegreeCdTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "DEGREE_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },


    /**
     * 상담 대분류 코드(CONSULT_CD)
     * searchText : 검색 단어
     */
    fncConsultLCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "CONSULT_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 상담 소분류(CONSULT_CD)
     * searchText : 검색 단어
     */
    fncConsultMCodes(lCodeCd, searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                level: 'M',
                codeGrpId: 'CONSULT_CD',
                lCodeCd: lCodeCd,
                perPage: 100,
                 codeNm: searchText
             },
             "post",
             callback,
            true
         );
     },   
    
    
    /**
     * 역대회장단  코드
     * searchText : 검색 단어
     */

    fncPresidencyCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "PRESIDENCY_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },
    /**
     * 입금처 코드
     * searchText : 검색 단어
     */
    fncDepositCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "DEPOSIT_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 행사주체분류 코드
     * searchText : 검색 단어
     */
    fncEventOrgCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "EVENTORG_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 행사구분 코드
     * searchText : 검색 단어
     */
    fncEventCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "EVENT_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 납입구분 코드
     * searchText : 검색 단어
     */
    fncFeeGbCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "FEE_GB_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 소모임구분 코드
     * searchText : 검색 단어
     */
    fncGroupCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "GROUP_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 과거 단체분류 코드
     * searchText : 검색 단어
     */
    fncPartCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "PARTY_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 직책 코드
     * searchText : 검색 단어
     */
    fncPositionCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "POSITION_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 회원관계 코드
     * searchText : 검색 단어
     */
    fncRelCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "REL_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 작업내역변경 코드
     * searchText : 검색 단어
     */
    fncWorkModCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "WRK_MOD_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 장학관리 - 학기 코드 semester_cd
     * searchText : 검색 단어
     */
    fncSemesterCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'SEMESTER_CD',
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },
    
    /**
     * 캠페인 대분류(CALL_USE_CD)
     * searchText : 검색 단어
     */
    fncCmpLTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'CALL_USE_CD',
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 캠페인 소분류(CALL_USE_CD)
     * searchText : 검색 단어
     */
    fncCmpSTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                level: "M",
                codeGrpId: 'CALL_USE_CD',
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

   /**
    * 상담 CALL 분류(CALL_CD)
    * searchText : 검색 단어
    */
   fncCmpCallTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'CALL_CD',
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

   /**
    * 캠페인 소분류(CALL_USE_CD)
    * searchText : 검색 단어
    */
   fncCmpMTypes(lCodeCd, searchText, callback) {
       kuaaApi.sendServer(
           this.comm_code_url,
           {
               level: 'M',
               codeGrpId: 'CALL_USE_CD',
               lCodeCd: lCodeCd,
               perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
           true
        );
    },

    /**
     * 상태 코드
     * searchText : 검색 단어
     */
    fncStateCodes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: "STATE_CD",
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 단체구분
     * searchText : 검색 단어
     */
    fncBranchTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'BRANCH_CD',
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 주소 시도 목록
     * searchText : 검색 단어
     */
    fncAddrSiDoTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'ADDR_SI_GU_CD',
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 주소 군 / 구 목록
     * searchText : 검색 단어
     */
    fncAddrGunGuTypes(lCodeCd, searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                level: 'M',
                codeGrpId: 'ADDR_SI_GU_CD',
                lCodeCd: lCodeCd,
                perPage: 100,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 우편물 수령처 목록
     * searchText : 검색 단어
     */
    fncPostReceiptTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'POST_RCT_CD',
                perPage: 10,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },

    /**
     * 우편물미수령 사유 목록
     * fncPostReceiptTypes(우편물 수령처 목록) 에서 '발송안함'을 선택한 경우만 활성화 시킨다
     * searchText : 검색 단어
     */
    fncNonPostReceiptTypes(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                level: 'M',
                codeGrpId: 'POST_RCT_CD',
                lCodeCd: '5',
                perPage: 20,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },


    fncClgSemesterCdList(searchText, callback) {
        kuaaApi.sendServer(
            this.comm_code_url,
            {
                codeGrpId: 'CLG_SEMESTER_CD',
                perPage: 50,
                codeNm: searchText
            },
            "post",
            callback,
            true
        );
    },


    fncMenuGrpList(callback) {
        kuaaApi.sendServer(
            URL_CONST.GET_MENU_GRP_LIST,
            {gridCombo:"Y"},
            "post",
            callback
        );
    },


    /**
     * dateStr : date String 202010232305
     * format : 변환할 date format string : 'YYYY-MM-DD'
     */
    getDateFormatter (dateStr, format){
        if(!format)  format = 'YYYY-MM-DD';
        if(dateStr && dateStr != ''){
            return dateStr.length > 8 ? moment(dateStr,'YYYYMMDDHHmm').format(format) : moment(dateStr).format(format);
        }else{
            return null;
        }
    },

    /**
     * dateStr string으로 return : 20201010
     */
    cleanDateFormatter(dateStr) {
        let res = dateStr && dateStr != '' ? moment(dateStr).format("YYYYMMDD") : '';
        return res;
    },

    alertSwal(title, messageType){
        let obj = {
            //icon: type,
            title: title,
            html: (messageType === "SAVE" || !messageType)? '저장 되었습니다.': messageType,
            //confirmButtonClass: "md-button md-warning",
            confirmButtonText: "확인",
            timer: 2000
        };
        return new Promise((r, e) => {
            resolve(Swal.fire(Object.assign({}, obj)));
        });
    },

    /**
     * title : 화면(업무명)
     * messageType : "SAVE" 또는 null인 경우 저장 메세지 출력, 그외 메세지인 경우 해당 메세지
     */
    showSwal(title, messageType, opt){
        let obj = {
            //icon: type,
            title: title,
            html: (messageType === "SAVE" || !messageType)? '저장 되었습니다.': messageType,
            confirmButtonClass: "md-button md-warning",
            confirmButtonText: "확인",
            timer: 2000
        };
        Swal.fire(Object.assign({}, obj, opt));
    },

    /**
     * 그리드 설정
     * @param url
     * @param isOnloadSearch : 그리드 생성시 조회 여부
     * @param pagination : 사용할 페이징 객체
     * @param rowHeaderType : default 'rownum',   'checbox'
     * @returns
     */
    setGridInit(readUrl, isOnloadSearch, pagination, rowHeaderType){
      let dataSource = {
        withCredentials: false,
        initialRequest: isOnloadSearch,
        api: {
          readData: {
            contentType: 'application/json',
            url: readUrl,
            method: 'POST'
          }
        },
        headers: { 'X-Auth-Token': session.get('token') }
      };

      class RowNumberRenderer {
        constructor(props) {
            const el = document.createElement('span');
            if(props.grid.getPagination())
                el.innerHTML = `${parseInt(props.grid.getPagination()._options.itemsPerPage) * (parseInt(props.grid.getPagination()._currentPage) -1) + parseInt(props.formattedValue)}`;
            else
                el.innerHTML = `${props.formattedValue}`;
            this.el = el;
        }

        getElement() {
            return this.el;
        }

        //render(props) {
        //    this.el.innerHTML = `${parseInt(props.grid.getPagination()._options.itemsPerPage) * (parseInt(props.grid.getPagination()._options.page) -1) + parseInt(props.formattedValue)}`;
        //}
      }
      
      let rowNum =  [
            {
                type: 'rowNum',
                renderer: {type: RowNumberRenderer}
            }
        ];
      let rowHeader = !rowHeaderType? rowNum: rowHeaderType;

      let  pageOptins = null;
      if(pagination){
          pageOptins = {perPage: pagination.perPage};
      }

      return  {
        el: null, //this.$refs.codeGrpGrid,
        usageStatistics: false,
        //useClientSort: false,
        options: {
//          minBodyHeight: 50,
          bodyHeight: 407,
          scrollX: true,
          scrollY: true,
          minRowHeight : 0,
          rowHeight: 26,
          selectionUnit: 'row',
          header:[
              {height: 50}
          ],
          pageOptions: pageOptins,
            copyOptions: {
                useFormattedValue: true,
                useListItemText: true
            }
        },
        rowHeaders: rowHeader,
  //      editingEvent: 'click',
        columnOptions: {
          resizable: true,
          sortable: true
          //frozenCount: 3
        },
        header:[
            {height: 50}
        ],
        columns: [],
        lang: {
          name: 'ko',
          value: {
            display: {
              noData: '데이터가 없습니다.',
              loadingData: '로딩중.'
            }
          }
        },
//        theme: 'striped',

        theme: {
          //presetName: 'striped',  // ['default', 'striped', 'clean']
          name: 'striped',
          value: {
            row : {
                even: {background: '#eaeaea', text:'black'}
            },
            cell: {
              normal: {background: '#eaeaea', border: '#e0e0e0', showVerticalBorder: true, showHorizontalBorder: true},
              header: {background: '#eaeaea', border: '#e0e0e0', showHorizontalBorder: true},
              rowHeader: {background: '#eaeaea', border: '#e0e0e0', showHorizontalBorder: true}
            }
          }
        },
        //  extOptions : selection : background
        //                           border
        data: dataSource
        // focusChange: function(ev) {
        //     this.setSelectionRange({
        //         start: [ev.rowKey, 0],
        //         end: [ev.rowKey, this.getColumns().length-1]
        //     });
        // }
      };
    },

    getSwalModaloptions (opt,cinfirmOpt){
      if(opt == 'confirm'){
        let obj = {
          title: "서버 전송",
          html: `서버에 전송 하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: "실행",
          cancelButtonText: "취소",
        };
        return Object.assign({}, obj, cinfirmOpt);
      }else{
        let obj = {
          showCancelButton: false,
          confirmButtonText: "확인",
          buttonsStyling: false,
          timer: 2000
        };
        return Object.assign({}, obj, opt);
      }
    },

    getDateGap (from,to){
      let fromDate = moment(from); //todays date
      let toDate = moment(to); // another date
      let duration = moment.duration(fromDate.diff(toDate));
      return duration.asDays();
    },

    scrollTo(target){
      let top = document.getElementById(target).offsetTop;
      setTimeout(function () {
        document.querySelector('.main-panel').scrollTop = top;
      },50);
    },

    parseYm (date){
      return date ? date.replace(/-/gi, "") : '';
    },

    getCurrentYear(){
      return moment().format('YYYY');
    },

    parseOnlyNum(str){
      return str ? str.replace(/-/gi, "") : '';
    },

    gridErrorCallback(e,title){
      let res = JSON.parse(e.xhr.response);
      let resultCode = res.resultCode;
      let resultMsg = res.resultMessage;
      let modalOptions = {
        showCancelButton: false,
        confirmButtonText: "확인",
        buttonsStyling: true,
        html : resultMsg
      };

      if(resultCode == '9102' || resultCode == '9104'){
        Swal.fire(modalOptions).then(result => {
          if (result.value) {
            window.location = '/login';
          }
        });
      }else{
        this.showSwal(title, resultMsg);
      }
    },

    setTab (){
      $(document).on('click','.tab-area .md-button', function () {
        $(this).siblings('.md-button').css('background-color', '#393636');
        $(this).css('background-color', '#000');
      });
    },

    destroyTab (){
      $(document).off('click','.tab-area .md-button');
    },

    resetPagenation(tgt, event, pagination){
        if(pagination.total == 0) return;
        tgt.invoke("setPerPage", event.target.value);
        tgt.invoke("getPagination").setItemsPerPage(event.target.value);
        tgt.invoke("getPagination").reset(pagination.total);
    }

};

export default kuaaFnc;
